// Use a selection-based fallback when the clipboard API is unavailable or
// denied, as can happen in embedded browsers. Reject if neither method works.
export async function copyText(text) {
  if (navigator.clipboard && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(text);
      return;
    } catch {
      // Continue with the browser's copy command.
    }
  }

  const focused = document.activeElement;
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.setAttribute("readonly", "");
  textarea.style.position = "fixed";
  textarea.style.top = "-1000px";
  document.body.appendChild(textarea);
  try {
    textarea.select();
    if (!document.execCommand("copy")) throw new Error("Could not copy text");
  } finally {
    textarea.remove();
    focused?.focus({ preventScroll: true });
  }
}
